import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Dashboard from "../Dashboard";
import Chicken from "../../../img/Chicken.png";
import ChillyPowder from "../../../img/ChillyPowder.png";
import FreshSpinach from "../../../img/FreshSpinach.png";
import ZoneSheets from "../../../img/ZoneSheets.svg";
import LabelSheets from "../../../img/LabelSheets.svg";
import GrocerySheets from "../../../img/GrocerySheets.svg";
import Header from "../Header/Header";
import { toast } from "react-toastify";
import { getIngredientslist, api_url, fmb_food_items_ingredients } from "../../../Redux/Reducer/AuthReducer";
import { useDispatch } from "react-redux";
import DateRangePicker from "react-bootstrap-daterangepicker";
import calender from '../../../img/Icon/calender.svg';
import CsvDownloader from 'react-csv-downloader';
import { CSVLink } from 'react-csv';
import Modal from "react-modal";
import fmblogo from "../../../img/fmb-logo.png";
import moment from "moment";
import loadergif from '../../../img/landing/loader123.gif';
import warningLogo from "../../../img/Icon/warning-round.svg"
import axios from "axios";

export default function TotalIngredients() {
const user_Role = localStorage.getItem("access_Role");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const dispatch = useDispatch();
  const location = useLocation();
  const ingredientscount = location?.state?.ingredientscountlist || [];
  const ingredcount = location?.state?.ingredientCountdata || [];
  const scheduleday = location?.state?.scheduledayweek || [];
  const scheduletype = location?.state?.scheduletype || [];
  const scheduleId = location?.state?.scheduleId || [];
  
  const [Ingredients, setIngredientsList] = useState(ingredientscount);
  const [IngredientsDate, setIngredientsDate] = useState(scheduleday);
  const [IngredientsThalicount, setIngredientsThalicount] = useState('');
  const [totalInventory, settotalInventory] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [RemoveIsOpen, setIsRemoveOpen] = React.useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [name, setName] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendor2, setVendor2] = useState("");
  const [vendor3, setVendor3] = useState("");
 const [unit, setUnit] = useState("");
  const [type, setType] = useState("");
  const [size, setSize] = useState(null);
  const [storage, setStorage] = useState("");
  const [ingredientnote, setIngredientNote] = useState("");
  const [image, setImage] = useState("");
  const [imagebinary, setImagebinary] = useState();
  const [packege, setPackege] = useState("");
  const [getstorage, setGetstorage] = useState("");
  const [getingredient, setGetIngredient] = useState("");
  const [updateImage, setUpdateImage] = useState("");
  const [packtype, setPacktype] = useState("");
  const [getunit, setGetunit] = useState("");
  const [getVendor, setGetvender] = useState("");
  const [unitdata, setUnitdata] = useState([]);
  const [venderdata, setVenderdata] = useState([]);
  const [typedata, setTypedata] = useState([]);
  const [cleartype, setCleartype] = useState([]);
  const [id, setId] = useState("");
  const [selectedVendorOption, setSelectedVendorOption] = useState(null);
  const [selectedUnitOption, setSelectedUnitOption] = useState(null);
  const [selectedPackageOption, setSelectedPackageOption] = useState(null);
  const [sortColumn, setSortColumn] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedIngredients, setSortedIngredients] = useState([]);
  const [standard, setStandard] = useState("0");
  const [updateteamoption, setUpdateteamoption] = useState("0");
  const [IngredientCost, setIngredientCost] = useState("");
  const [totalcount, setTotalCount] = useState("");
  const [EventIsOpen, setIsEventOpen] = React.useState(false);
  const [EventType, setEventType] = useState([]);
  const [customUnit, setCustomUnit] = useState("");
  const [outdatedIngredients, setUpdateOutdatedIngredients] = useState(0);
  const [costUpdatedAt, setCostUpdatedAt] = useState("");
  const [is_niyaaz, setIsNiyaaz] = useState("0");


  const [validationerror, setValidationerror] = useState(false)
  

  console.log('scheduleday', scheduleday)

  const isOlderThanSixMonths = (dateString) => {
    if (!dateString) return false;
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 3);
    return new Date(dateString) < sixMonthsAgo;
  };

  // const handleSelectChange = (event) => {
  //   setSelectedOption(event.target.value);
  //   const requestBody = {
  //     schedule_id: selectdatelist,
  //     by_day: event.target.value
  //   };
  //   getselectdatachange(requestBody)
  // };

  function RemoveOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }
  function RemoveModal() {
    setIsRemoveOpen(true);

  }

  function RemovecloseModal() {
    setIsRemoveOpen(false);

  }


  const getIngredientsId = (
  ) => {
    const requestBody = {
      schedule_id: scheduleId,
    };

    let url = scheduletype === "FMBTHALI" ? "ingredients-get-by-id" : "ingredients-get-by-id-miqat"

    if (scheduletype == "FMBTHALI" && is_niyaaz == '1'){
      url = "ingredients-get-by-id-fmb-niyaz"
    }

    fetch(fmb_food_items_ingredients + "admin/" + url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("access_token"),
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === true) {
          const ingredientsList = data.data;
          setIngredientsList (ingredientsList)
        } else {
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };



    const handleupdateSubmit = (e) => {
    e.preventDefault();
    // const data = new FormData();

    if (
      !name ||
      // !size ||
      // !ingredientnote ||
      !getunit
      // !getstorage
      // !type ||
      // !vendor
      // !vendor2 ||
      // !vendor3
      // updateImage === null
    ) {
      setValidationerror(true);
      return false;
    } else {
      const postData = {
        file: updateImage,
        ingredient_id: id,
        ingredient_name: name,
        package_type: type,
        package_size: size,
        // storage_location: getstorage.value,
        ingredient_note: getingredient,
        vendor_name1: vendor,
        vendor_name2: vendor2,
        vendor_name3: vendor3,
        standard: updateteamoption,
        ingredient_cost: IngredientCost,
        package_unit: getunit,
      };
      console.log(postData, "postData");
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      };

      axios
        .put(
          fmb_food_items_ingredients + `admin/ingredients-update`,
          postData,
          config,
          {}
        )
        .then((res) => {
          if (res?.data?.status == true) {
            toast.success(res?.data?.message, {
              autoClose: 5000,
            });
            getIngredientsId ()
            const modal_close2 = document.getElementById("close_btn2").click();
            setValidationerror(false);
          } else {
            toast.error(res?.data?.message);
          }
        });
    }
  };

    const preventMinus = (e) => {
    if (e.code === 'Minus') {
        e.preventDefault();
    }
  };

    const handleToggleChange = (e) => {
    const newValue = standard === "1" ? "0" : "1";
    setStandard(newValue);
  };

  const handleToggleChange2 = (e) => {
    const newValue = updateteamoption === "1" ? "0" : "1";
    setUpdateteamoption(newValue);
  };

  const handleToggleOutdatedChange = (e) => {
    const newValue = outdatedIngredients == 1 ? 0 : 1;
    setUpdateOutdatedIngredients(newValue);
  };



  const [selectedOption, setSelectedOption] = useState(true);








  // const getIngredients = () => {
  //   dispatch(getIngredientslist()).then((res) => {
  //     if (res?.payload?.status == true) {
  //       setIngredientsList(res?.payload?.data);
  //     } else {
  //       toast.error(res?.payload?.message);
  //     }
  //   });
  // };


  // useEffect(() => {
  //   getIngredients();
  // }, []);

  useEffect(() => {
    // setIngredientsDate(Ingredients.schedule_day ? Ingredients.schedule_day : "-");
    setIngredientsThalicount(Ingredients?.thaaliCount);
    settotalInventory(ingredcount);
  }, []);

    const unitlist = unitdata.map((item) => {
    return {
      label: item.name,
      value: item._id,
    };
  });


  const dataget = (item) => {
    setName(item.ingredient_name);
    setSize(item.package_size);
    setType(item.package_type);
    setGetstorage(item.storage_location);
    setGetIngredient(item.ingredient_note);
    setIngredientCost(item.ingredient_cost);
    setGetunit(item.package_unit);
    var result = unitlist.filter(function (unitItem) {
        return unitItem.label === item.package_unit;
    });
    result.length === 0 ? setCustomUnit("Enter Custom") : setCustomUnit(item.package_unit)
    setVendor(item.vendor_name1);
    setVendor2(item.vendor_name2);
    setVendor3(item.vendor_name3);
    setId(item.ingredient_id);
    setUpdateteamoption(item.standard);
    setCostUpdatedAt(item.cost_updated_at)
  };


  const formatDate = (dateString) => {
    if (!dateString) {
      return ""; // return empty string if dateString is undefined or empty
    }

    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });

    if (isNaN(day)) {
      return ""; // return empty string if parsing fails
    }

    return `${day} ${month}`;
  };



  // csv file download 

  const csvData = Ingredients.schedule.map((items) => {
    const formattedDate = new Date(items?.schedule_day).toLocaleDateString();
    const startIndex = items?.menu?.indexOf('"') + 1;
    const endIndex = items?.menu?.lastIndexOf('"');
    const extractedText = items?.menu?.substring(startIndex, endIndex);
    return {
      Date: formattedDate || "-",
      IngredientName: items.ingredient_name,
      PackageUnit: items.package_unit,
      Menu: extractedText || "",
      PackageType: items.package_type || "-",
      PackageSize: items.package_size,
      VendorName: items.vendor_name1,
      Quantity: items.menu_quantity || items.total_quantity,
    };
  });

  const csvHeaders = [
    { label: "Date", key: "Date" },
    { label: "Ingredient Name", key: "IngredientName" },
    { label: "Package Unit", key: "PackageUnit" },
    { label: "Menu", key: "Menu" },
    { label: "Package Type", key: "PackageType" },
    { label: "Package Size", key: "PackageSize" },
    { label: "Vendor Name", key: "VendorName" },
    { label: "Quantity", key: "Quantity" },
  ];


  // pagination
  const itemsPerPage = Ingredients?.schedule?.length; // Set the number of items to display per page
  const totalItems = Ingredients?.schedule?.length || 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);


  // Function to handle page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Function to get the items to display on the current page
  const getCurrentPageItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return Ingredients?.schedule?.slice(startIndex, endIndex) || [];

  };
  console.log('getCurrentPageItems', getCurrentPageItems)



  return (
    <div>
      <Header />
      <div className="main_section exp_in">
        <div className="ExportInventory thali_section">
          <div className="container-fluid">
            <div className="thili_div">
              <div className="Back-page">
                {" "}
                <Link to="/Dashboard">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.175 15.4748L0.225 8.5248C0.141667 8.44147 0.0833335 8.35814 0.0500002 8.2748C0.0166669 8.19147 0 8.0998 0 7.9998C0 7.8998 0.0166669 7.80814 0.0500002 7.7248C0.0833335 7.64147 0.141667 7.55814 0.225 7.4748L7.2 0.499804C7.33333 0.366471 7.5 0.299805 7.7 0.299805C7.9 0.299805 8.075 0.374805 8.225 0.524805C8.375 0.674805 8.45 0.849805 8.45 1.0498C8.45 1.2498 8.375 1.4248 8.225 1.5748L2.55 7.2498H14.95C15.1667 7.2498 15.3458 7.32064 15.4875 7.4623C15.6292 7.60397 15.7 7.78314 15.7 7.9998C15.7 8.21647 15.6292 8.39564 15.4875 8.5373C15.3458 8.67897 15.1667 8.7498 14.95 8.7498H2.55L8.25 14.4498C8.38333 14.5831 8.45 14.7498 8.45 14.9498C8.45 15.1498 8.375 15.3248 8.225 15.4748C8.075 15.6248 7.9 15.6998 7.7 15.6998C7.5 15.6998 7.325 15.6248 7.175 15.4748Z"
                      fill="#777391"
                    />
                  </svg>
                </Link>

                <h1 className="title_heading">
                  &nbsp; &nbsp; &nbsp; View FMB Ingredients
                </h1>
              </div>
            </div>

            <div className="ExportInventory_calender">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="Week_list hover_remove">
                    <div className="week_img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="28"
                        viewBox="0 0 24 28"
                        fill="none"
                      >
                        <path
                          d="M6.33333 15.9998C6.04444 15.9998 5.80556 15.9054 5.61667 15.7165C5.42778 15.5276 5.33333 15.2887 5.33333 14.9998C5.33333 14.7109 5.42778 14.4721 5.61667 14.2832C5.80556 14.0943 6.04444 13.9998 6.33333 13.9998H17.6667C17.9556 13.9998 18.1944 14.0943 18.3833 14.2832C18.5722 14.4721 18.6667 14.7109 18.6667 14.9998C18.6667 15.2887 18.5722 15.5276 18.3833 15.7165C18.1944 15.9054 17.9556 15.9998 17.6667 15.9998H6.33333ZM6.33333 21.9998C6.04444 21.9998 5.80556 21.9054 5.61667 21.7165C5.42778 21.5276 5.33333 21.2887 5.33333 20.9998C5.33333 20.7109 5.42778 20.4721 5.61667 20.2832C5.80556 20.0943 6.04444 19.9998 6.33333 19.9998H13.6333C13.9222 19.9998 14.1611 20.0943 14.35 20.2832C14.5389 20.4721 14.6333 20.7109 14.6333 20.9998C14.6333 21.2887 14.5389 21.5276 14.35 21.7165C14.1611 21.9054 13.9222 21.9998 13.6333 21.9998H6.33333ZM2 27.3332C1.46667 27.3332 1 27.1332 0.6 26.7332C0.2 26.3332 0 25.8665 0 25.3332V4.6665C0 4.13317 0.2 3.6665 0.6 3.2665C1 2.8665 1.46667 2.6665 2 2.6665H4.16667V1.73317C4.16667 1.44428 4.27222 1.19428 4.48333 0.983171C4.69444 0.772059 4.95556 0.666504 5.26667 0.666504C5.55556 0.666504 5.80556 0.772059 6.01667 0.983171C6.22778 1.19428 6.33333 1.44428 6.33333 1.73317V2.6665H17.6667V1.73317C17.6667 1.44428 17.7722 1.19428 17.9833 0.983171C18.1944 0.772059 18.4556 0.666504 18.7667 0.666504C19.0556 0.666504 19.3056 0.772059 19.5167 0.983171C19.7278 1.19428 19.8333 1.44428 19.8333 1.73317V2.6665H22C22.5333 2.6665 23 2.8665 23.4 3.2665C23.8 3.6665 24 4.13317 24 4.6665V25.3332C24 25.8665 23.8 26.3332 23.4 26.7332C23 27.1332 22.5333 27.3332 22 27.3332H2ZM2 25.3332H22V10.9998H2V25.3332Z"
                          fill="#957137"
                        />
                      </svg>
                    </div>

                    <div className="week_text">
                      <h4>DAY BY</h4>
                      <h1>{formatDate(IngredientsDate)}-{formatDate(IngredientsDate)}</h1>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <Link t>
                    <div className="Week_list INGREDIENTS_Cout hover_remove">
                      <div className="week_img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="26"
                          viewBox="0 0 20 26"
                          fill="none"
                        >
                          <path
                            d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                            fill="#591333"
                          />
                        </svg>
                      </div>
                      <div className="week_text">
                        <h4>{scheduletype === "FMBTHALI" ? "Thaali Count" : "Thaal Count"} </h4>
                        <h1>{IngredientsThalicount ? IngredientsThalicount : '-'}</h1>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-md-6">
                  <Link to="">
                    <div className="Week_list Thali_Count  my-0 my-md-3 my-lg-0 hover_remove">
                      <div className="week_img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                        >
                          <path
                            d="M10.8998 19.3332C11.5887 19.3332 12.1665 19.0943 12.6332 18.6165C13.0998 18.1387 13.3332 17.5665 13.3332 16.8998C13.3332 16.2332 13.0998 15.6609 12.6332 15.1832C12.1665 14.7054 11.5998 14.4665 10.9332 14.4665C10.2443 14.4665 9.66095 14.7054 9.18317 15.1832C8.70539 15.6609 8.4665 16.2332 8.4665 16.8998C8.4665 17.5665 8.70539 18.1387 9.18317 18.6165C9.66095 19.0943 10.2332 19.3332 10.8998 19.3332ZM17.0998 19.3332C17.7665 19.3332 18.3387 19.0943 18.8165 18.6165C19.2943 18.1387 19.5332 17.5665 19.5332 16.8998C19.5332 16.2332 19.2943 15.6609 18.8165 15.1832C18.3387 14.7054 17.7665 14.4665 17.0998 14.4665C16.4332 14.4665 15.8609 14.7054 15.3832 15.1832C14.9054 15.6609 14.6665 16.2332 14.6665 16.8998C14.6665 17.5665 14.9054 18.1387 15.3832 18.6165C15.8609 19.0943 16.4332 19.3332 17.0998 19.3332ZM13.9998 13.0998C14.6665 13.0998 15.2387 12.8665 15.7165 12.3998C16.1943 11.9332 16.4332 11.3554 16.4332 10.6665C16.4332 9.99984 16.1943 9.42762 15.7165 8.94984C15.2387 8.47206 14.6665 8.23317 13.9998 8.23317C13.3332 8.23317 12.7609 8.47206 12.2832 8.94984C11.8054 9.42762 11.5665 9.99984 11.5665 10.6665C11.5665 11.3554 11.8054 11.9332 12.2832 12.3998C12.7609 12.8665 13.3332 13.0998 13.9998 13.0998ZM13.9998 27.3332C12.1776 27.3332 10.4554 26.9832 8.83317 26.2832C7.21095 25.5832 5.79428 24.6276 4.58317 23.4165C3.37206 22.2054 2.4165 20.7887 1.7165 19.1665C1.0165 17.5443 0.666504 15.8109 0.666504 13.9665C0.666504 12.1443 1.0165 10.4221 1.7165 8.79984C2.4165 7.17762 3.37206 5.7665 4.58317 4.5665C5.79428 3.3665 7.21095 2.4165 8.83317 1.7165C10.4554 1.0165 12.1887 0.666504 14.0332 0.666504C15.8554 0.666504 17.5776 1.0165 19.1998 1.7165C20.8221 2.4165 22.2332 3.3665 23.4332 4.5665C24.6332 5.7665 25.5832 7.17762 26.2832 8.79984C26.9832 10.4221 27.3332 12.1554 27.3332 13.9998C27.3332 15.8221 26.9832 17.5443 26.2832 19.1665C25.5832 20.7887 24.6332 22.2054 23.4332 23.4165C22.2332 24.6276 20.8221 25.5832 19.1998 26.2832C17.5776 26.9832 15.8443 27.3332 13.9998 27.3332Z"
                            fill="#1F2F32"
                          />
                        </svg>
                      </div>
                      <div className="week_text">
                        <h4>Total Ingredients</h4>
                        <h1>{totalInventory ? totalInventory : '-'}</h1>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>


              <div className="thali_table_inventory_section mt-5">
                <table className="table table-bordered">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">
                        <span className="thali_table">Day</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Menu</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Ingredient  Name</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">QTY (Actual)</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">{scheduletype === "FMBTHALI" ? "QTY (100 Thaalis)" : "QTY (10 Thaals)"}</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Unit</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">PKG Size</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Vendor</span>
                      </th>
                      {
                       (user_Role.includes("ADM") || user_Role.includes("OPT")) && 
                       <th scope="col">
                        <span className="thali_table">Cost</span>
                       </th>
                      }
                      <th scope="col">
                        <span className="thali_table">Notes</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Action</span>
                      </th>
                    </tr>
                  </thead>
                  {getCurrentPageItems() && getCurrentPageItems().map((items, index) => {
                    const formattedDate = new Date(items?.schedule_day).toLocaleDateString();
                    const startIndex = items?.menu?.indexOf('"') + 1;
                    const endIndex = items?.menu?.lastIndexOf('"');
                    const extractedText = items?.menu?.substring(startIndex, endIndex);
                    const menuArray = extractedText?.split(/,|"/).map(item => item?.replace(/-/g, ''));
                    return (
                      <tbody
                        key={items.id}
                      >
                        <tr>

                          <th scope="row">
                            <ul className="thali_menu_list">
                              <li>
                                {moment(IngredientsDate).format("MM/DD/YYYY")}
                                {/* {formattedDate} */}
                              </li>
                            </ul>
                          </th>
                          <th scope="row">
                            <ul className="thali_menu_list">
                              <li>
                                {items.dish_name}
                              </li>
                            </ul>
                          </th>

                          <th scope="row">
                            <ul className="thali_menu_list">
                              <li>
                                {items.ingredient_name}
                              </li>
                            </ul>
                          </th>
                          <th scope="row">
                            <ul className="thali_menu_list">
                              <li> {items.total_quantity
                                    ? items.total_quantity // Assuming you want two decimal places
                                    : '-'}</li>
                                </ul>
                              </th>
                              <th scope="row">
                            <ul className="thali_menu_list">
                              <li>   {items.menu_quantity
                                      ? items.menu_quantity // Assuming you want two decimal places
                                      : '-'}</li>
                            </ul>
                          </th>
                          <th scope="row">
                            <ul className="thali_menu_list">
                              <li> {items.package_unit ? items.package_unit : '-'}</li>
                            </ul>
                          </th>
                          <th scope="row">
                            <ul className="thali_menu_list">
                              <li> {items.package_size}</li>
                            </ul>
                          </th>
                          <th scope="row">
                            <ul className="thali_menu_list">
                              <li> {items.vendor_name1}</li>
                            </ul>
                          </th>
                         {
                          (user_Role.includes("ADM") || user_Role.includes("OPT")) && 
                            <th scope="row" style={{ position: "relative" }}>
                              <ul className="thali_menu_list">
                                <li>
                                  {/* Ingredient Cost Display */}
                                  <span
                                    style={{
                                      color: isOlderThanSixMonths(items.cost_updated_at) ? "#993530" : "inherit",
                                    }}
                                  >
                                    {items.ingredient_cost || "-"}
                                  </span>

                                  {/* Info Icon (Visible for all items with a price) */}
                                  {items.cost_updated_at && (
                                    <>
                                      <img
                                        src={warningLogo}
                                        style={{
                                          marginLeft: "8px",
                                          cursor: "pointer",
                                          width: "16px",
                                          height: "16px",
                                          filter: isOlderThanSixMonths(items.cost_updated_at)
                                            ? "none" // Red color
                                            : "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)", // Black color
                                        }}
                                        // onMouseEnter={() => setIsTooltipVisible(index)}
                                        // onMouseLeave={() => setIsTooltipVisible(null)}
                                        onClick={() => setIsTooltipVisible(isTooltipVisible === index ? null : index)}
                                      />

                                      {/* Custom Tooltip */}
                                      {isTooltipVisible === index && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "10px",
                                            backgroundColor: "#333",
                                            color: "#fff",
                                            padding: "6px 10px",
                                            borderRadius: "5px",
                                            fontSize: "12px",
                                            zIndex: 1000,
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          Last updated on: {new Date(items.cost_updated_at).toLocaleDateString()}
                                        </div>
                                      )}
                                    </>
                                  )}
                                </li>
                              </ul>
                            </th>
                          }
                          <th scope="row">
                            <ul className="thali_menu_list">
                              <li> {items.ingredient_note && items.ingredient_note != "NULL"
                                      ? items.ingredient_note // Assuming you want two decimal places
                                      : '-'}</li>
                            </ul>
                          </th>
                          <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  <div class="dropdown action_btn">
                                    <button
                                      class="btn btn-secondary dropdown-toggle"
                                      type="button"
                                      id="dropdownMenuButton2"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i
                                        className="fa fa-ellipsis-h"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton2"
                                    >
                                      { (user_Role.includes("ADM") || user_Role.includes("PRM")) &&
                                      <li>
                                        <a
                                          onClick={() => dataget(items)}
                                          class="dropdown-item"
                                          data-bs-toggle="offcanvas"
                                          data-bs-target="#offcanvasRightEditCost"
                                          aria-controls="offcanvasRightEditCost"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="19"
                                            height="15"
                                            viewBox="0 0 19 15"
                                            fill="none"
                                          >
                                            <path
                                              d="M17.125 8.65L15.35 6.875L16.075 6.15C16.2135 6.01667 16.3898 5.95 16.6039 5.95C16.818 5.95 16.9917 6.01667 17.125 6.15L17.85 6.875C17.9833 7.01352 18.05 7.18982 18.05 7.4039C18.05 7.61797 17.9833 7.79167 17.85 7.925L17.125 8.65ZM9 15V13.225L14.275 7.95L16.05 9.725L10.775 15H9ZM0.75 9.75C0.335787 9.75 0 9.41421 0 9C0 8.58579 0.335786 8.25 0.75 8.25H6.75C7.16421 8.25 7.5 8.58579 7.5 9C7.5 9.41421 7.16421 9.75 6.75 9.75H0.75ZM0.75 5.625C0.335786 5.625 0 5.28921 0 4.875C0 4.46079 0.335786 4.125 0.75 4.125H11C11.4142 4.125 11.75 4.46079 11.75 4.875C11.75 5.28921 11.4142 5.625 11 5.625H0.75ZM0.75 1.5C0.335786 1.5 0 1.16421 0 0.75C0 0.335786 0.335786 0 0.75 0H11C11.4142 0 11.75 0.335786 11.75 0.75C11.75 1.16421 11.4142 1.5 11 1.5H0.75Z"
                                              fill="#777391"
                                            />
                                          </svg>{" "}
                                          &nbsp; &nbsp;Edit Cost
                                        </a>
                                      </li>
                                      }
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                            </th>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>

              </div>
              {/* Pagination */}
              {/* <nav>
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => handlePageChange(1)}>
                      First
                    </button>
                  </li>

                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                      Previous
                    </button>
                  </li>

                  {Array.from({ length: totalPages }, (_, index) => index + 1).map((pageNumber) => (
                    <li
                      className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}
                      key={pageNumber}
                    >
                      <button className="page-link pagebutton" onClick={() => handlePageChange(pageNumber)}>
                        {pageNumber}
                      </button>
                    </li>
                  ))}

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                      Next
                    </button>
                  </li>

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => handlePageChange(totalPages)}>
                      Last
                    </button>
                  </li>
                </ul>
              </nav> */}
              <div className="thili_div">
                <div className="Back-page">
                  {" "}
                  {/* <h1 className="title_Allow">
                    {" "}
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                        checked
                      />
                    </div>
                    Allow Exporting
                  </h1> */}
                </div>
                {/* <div className="Back-page">
                  <button className="btn thali_btn">Cancel</button>&nbsp; &nbsp;
                  &nbsp;{" "}
                  <button className="btn thali_btn csvbtn">
                    <CSVLink data={csvData} headers={csvHeaders} filename={"inventory.csv"}>
                      Export Ingredients
                    </CSVLink>
                  </button>

                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div />
            <div
        className="offcanvas offcanvas-end Dishes_canvas Cartere_canvas"
        tabindex="-1"
        id="offcanvasRightEditCost"
        aria-labelledby="offcanvasRightEditCost"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightEditLabel">
            Edit Ingredient Cost
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="Dish_Name_list">
            <form className="row g-3">
              <div className="col-md-12">
                <div className="Form_box">
                  <label for="inputDishName" className="form-label">
                    Ingredient Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your ingredient name"
                    disabled
                    className={`${
                      validationerror && !name
                        ? "validation_valid form-control"
                        : "form-control"
                    }`}
                    id="inputDishName"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                  />
                  {validationerror && !name && (
                    <p className="show_invalid_text">Name is Required</p>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="inputCaterer" className="form-label" style={{ position: "relative" }}>
                     {IngredientCost && (
                        <>
                        <span style={{color: isOlderThanSixMonths(costUpdatedAt) ? "#993530" : "inherit"}}>Ingredient Cost</span>
                          <img
                            src={warningLogo}
                            style={{
                              marginLeft: "8px",
                              cursor: "pointer",
                              width: "16px",
                              height: "16px",
                              filter: isOlderThanSixMonths(costUpdatedAt)
                                ? "none" // Red color
                                : "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)", // Black color
                            }}
                            onMouseEnter={() => setIsTooltipVisible(99)}
                            onMouseLeave={() => setIsTooltipVisible(null)}
                            onClick={() => setIsTooltipVisible(isTooltipVisible === 99 ? null : 99)}
                          />

                          {/* Custom Tooltip */}
                          {isTooltipVisible === 99 && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: "20%",
                                backgroundColor: "#333",
                                color: "#fff",
                                padding: "6px 10px",
                                borderRadius: "5px",
                                fontSize: "12px",
                                zIndex: 1000,
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Last updated on: {new Date(costUpdatedAt).toLocaleDateString()}
                            </div>
                          )}
                        </>)}
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Ingredient Cost"
                    // className={`${validationerror && !ingredientnote ? "validation_valid form-control" : "form-control"}`}
                    className="form-control"
                    id="inputDishName"
                    step="any"
                    min="0"
                    onKeyDown={preventMinus}
                    onWheel={() => document.activeElement.blur()}
                    onChange={(e) => setIngredientCost(e.target.value)}
                    value={IngredientCost}
                  />
                  {/* {
                    validationerror && !ingredientnote &&
                    <p className="show_invalid_text" >ingredient note is required</p>
                  } */}
                </div>
              </div>
              <div className="Ingredients_title">
                <h1></h1>
                <div className="Save_btn">
                  <button
                    type="button"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    id="close_btn2"
                  >
                    Cancel
                  </button>
                  <button onClick={handleupdateSubmit}>
                    Update Ingredient
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>


    </div>


  );
}
